import { AlertTriangle, Printer } from "lucide-react";

export const TIP_TOTAL_LABEL = "Tip-Out Amount Before Taxes";
const TITLE = "IMPORTANT — TIP-OUT AMOUNTS BEFORE TAXES";
const PARAS = [
  "Amounts shown reflect recorded tip-out calculations before applicable taxes, withholding, and other payroll adjustments. This report is not a pay statement or confirmation of payment. Refer to your employer’s payroll processor or final pay statement for your actual payment amount.",
  "Contact your restaurant owner or payroll administrator with questions or discrepancies, or use “Request a correction” on the report.",
  "This notice does not change your entitlement to earned tips or your employer’s payroll and payment obligations.",
];

export function TipNotice({ testid = "tip-notice" }) {
  return (
    <div role="note" className="rounded-xl border-2 border-[#9E2A2B]/70 bg-orange-50 p-4 text-sm leading-relaxed text-stone-800 break-words print:break-inside-avoid" data-testid={testid}>
      <div className="flex items-start gap-2 font-semibold text-[#9E2A2B] mb-1.5"><AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" aria-hidden />{TITLE}</div>
      {PARAS.map((p) => <p key={p.slice(0, 20)} className="mt-1.5">{p}</p>)}
    </div>
  );
}

export const PrintButton = ({ testid }) => (
  <button type="button" onClick={() => window.print()} className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-stone-900 print:hidden" data-testid={testid}><Printer className="h-4 w-4" />Print</button>
);
